<template>
  <!-- AppShell template file -->
  <div id="app">
    <router-view />
    <div id="portal-destination"></div>
    <div id="tooltip-portal"></div>
  </div>
</template>
<script setup lang="ts">
defineOptions({ name: 'AppShell' })
</script>
<style scoped lang="scss" src="./app-shell.scss"></style>
